import Env from 'Services/Env';

window.ThirdMap = {
	map : null,
	markers : {},
	infos : {},
	
	buildedMarkers : 0,
	bounds : null,
	
	init : function(divId) {
		
		// by default the id of div is "globalMap"
		divId	= typeof divId !== 'undefined' ? divId	: 'globalMap';
        
        if(!ThirdMap.map) {
            ThirdMap.map = L.map(document.getElementById(divId));
                
            ThirdMap.map.attributionControl.addAttribution('<a href="https://www.jawg.io" target="_blank">&copy; Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank">&copy; OpenStreetMap</a>&nbsp;contributors')
            L.tileLayer('https://tile.jawg.io/jawg-sunny/{z}/{x}/{y}.png?access-token=' + Env.get('jawg').token, {}).addTo(ThirdMap.map);
            ThirdMap.map.setView(L.latLng(48.856614, 2.352222),4);
            
            ThirdMap.layerGroup = L.layerGroup().addTo(ThirdMap.map);
        }
		
	},
	
	resetMarkers : function() {
        ThirdMap.layerGroup.clearLayers();
		ThirdMap.buildedMarkers = 0;
	},
	
	/*
	 * data:
	 * - id
	 * - lat
	 * - lng
	 * - geocode
	 * - name
	 * - linked
	 */
	addMarker : function(data) {
        
		if(Utils.in_array(data.id, ThirdMap.markers)) {
			// already in `ThirdMap.markers` (fuckin' easy)
			
			// point
			ThirdMap.markers[data.id].setMap(ThirdMap.map);
			
		} else {
			// not in `ThirdMap.markers`
			
			if(data.lat !== "" && data.lng !== "") {
				// the data contains a lat & lng values (easy win)
				
				var htmlContent = ThirdMap.__addMarker_generateHtml(data.name, data.linked, data.linkedtype);
				
				// point & infos
				var coords = L.latLng(data.lat, data.lng);
				
				ThirdMap.__addMarker_createMarker(data.id, htmlContent, coords);
				
				ThirdMap.buildedMarkers += 1;
			} else if (data.geocode !== "") {
                
				// pas de latitude mais une adresse ! (harder (... better, faster, stronger))
                
                $.ajax({
                    "method" : "GET",
                    "url" : "/?_f=address&action=geocode",
                    "data"  : {
                        address : {
                            "part1"         : data.part1,
                            "zip"           : data.zip,
                            "countrycode"   : data.countrycode,
                            "town"          : data.town,
                            "fullAddress"   : data.geocode,   
                            "id"            : data.id,
                        }
                    },
                    "dataType" : "JSON",
                });
                
			}
		}
	},
	
	// privates methods for `ThirdMap.addMarker`

	__addMarker_createMarker : function(id, htmlContent, coords) {
        
        ThirdMap.markers[id] = L.marker(coords);
        ThirdMap.markers[id].addTo(ThirdMap.layerGroup);
		// infos
		if(htmlContent !== "") {
            ThirdMap.markers[id].bindPopup(htmlContent);
		}

		
	},
	
	__addMarker_generateHtml : function(name, id, type) {
		if(name === "") {
			return '';
		}
		
		switch(type) {
			default:
			case 'third':
				return '<a href="/?_f=third&thirdid=' + id + '&thirdtype=' + type + '">' + name + '</a>';
				break;
			case 'people':
				return '<a href="/?_f=people&id=' + id + '">' + name + '</a>';
				break;
		}
	},
	
	updateMap : function(selector) {
		
		
		ThirdMap.resetMarkers();
		
		$(selector).each(function(){
			
			var $toMark = $(this);

			var pointData = {
				id			: $toMark.find('input[name=id]').val(),
				lat			: $toMark.find('input[name=lat]').val(),
				lng			: $toMark.find('input[name=lng]').val(),
				geocode		: $toMark.find('input[name=geocode]').val(),
				name		: $toMark.find('input[name=name]').val(),
				linked		: $toMark.find('input[name=linkedid]').val(),
				linkedtype	: $toMark.find('input[name=linkedtype]').val(),
				part1		: $toMark.find('input[name=part1]').val(),
				zip	        : $toMark.find('input[name=zip]').val(),
				countrycode	: $toMark.find('input[name=countrycode]').val()
			};
			
			ThirdMap.addMarker(pointData);
		});
	},
	
	closeAllInfos : function() {
		for (var i in ThirdMap.infos) {
			ThirdMap.infos[i].close();
		}
	},
	
	checkBounds : function() {
		if(ThirdMap.buildedMarkers > 0){
			ThirdMap.map.fitBounds(ThirdMap.bounds);			
		}else{
			if (ThirdMap.map){
				ThirdMap.map.setCenter(new google.maps.LatLng(48.856614, 2.352222));
				ThirdMap.map.setZoom(3);
			}
			
		}
	}
};
